import React from 'react';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { ProviderType } from './DocumentVault.meta';

interface Props {
  clientId: string;
  navigateTo: string | null;
}

/**
 * This component ensures backwards compatibility with the previous route scheme:
 * /document_vault/:clientId/:navigateTo
 *
 * `navigateTo` was being used to provide direct links to folders in email notifications.
 * This hack was needed since the previous route scheme was not folder path aware.
 */
export const DocumentVaultRedirect: React.FC<Props> = ({ clientId, navigateTo }) => {
  useEffectOnce(() => {
    ADV.util.Router.go2('DocumentVault', {
      clientId,
      path: navigateTo || '',
      providerType: ProviderType.All,
    });
  });

  return null;
};
